import $ from 'jquery';

$(function(){
    $(window).scroll(function(){
        var height = $(document).scrollTop();
        var bodyHalf = $('body').height() / 3;

        if( height > bodyHalf ) {
            $('.b-button--anchor').addClass("show-flex");
        } else {
            $('.b-button--anchor').removeClass('show-flex')
        }
    })

    $('.b-button--anchor').click(function(){
        $('html,body').stop().animate({
            scrollTop: '0'
        });
    })

    $(document).on('click', '.js-anchor', function (e) {
        e.preventDefault();
        var id  = $(this).attr('href'),
            top = $(id).offset().top - $('.js-longrid-menu-new').height();
        $('body, html').animate({scrollTop: top}, 500);
    });
});



// WEBPACK FOOTER //
// ./src/js/general/anchor.js